import React from 'react';
import './DiscoverMore.scss';

import { useAppSelector } from '../../stories/hooks';

// Interfaces for component props
interface DiscoverPodProps {
  imgSrc: string;
  heading: string;
  descriptionHTML: { __html: string };
  linkHTML: { __html: string };
}

// DiscoverPod component
const DiscoverPod: React.FC<DiscoverPodProps> = ({
    imgSrc,
    heading,
    descriptionHTML,
    linkHTML,
}) => (
    <div style={{ paddingTop: '10px', paddingBottom: '10px' }} className="col-12 col-md-4">
        <div className="discover-pod">
            <img src={imgSrc} alt="" aria-hidden="true" className="pod-image" />
            <div className="content-wrapper p-3">
                <h3 className="h3" style={{ marginTop: 0, marginBottom: 0 }}>{heading}</h3>
                <div className="content-description" dangerouslySetInnerHTML={descriptionHTML} />
                <div className="content-link" dangerouslySetInnerHTML={linkHTML} />
            </div>
        </div>
    </div>
);

// DiscoverMore component
const DiscoverMore = () => {
    const discoverMore = useAppSelector((state) => state.borrowingPower.data.discoverMore);

    const sanitize = (htmlString: string, isLink: boolean): { __html: string } => ({
        __html: htmlString,
    });

    return (
        <>
            <h3>{discoverMore.heading}</h3>
            <div className="row">
                {discoverMore.pods.map((pod) => (
                    <DiscoverPod
                        key={`${pod.imgSrc}-${pod.heading}`}
                        imgSrc={`${process.env.PUBLIC_URL}/${pod.imgSrc}`}
                        heading={pod.heading}
                        descriptionHTML={sanitize(pod.description, false)}
                        linkHTML={sanitize(pod.link, true)}
                    />
                ))}
            </div>
        </>
    );
};

export default DiscoverMore;
